"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecaptchaTokenService = void 0;
var RecaptchaTokenService = /** @class */ (function () {
    function RecaptchaTokenService() {
        // is public and for all domains the same
        this.containerId = 'recaptcha-token';
        this.sitekey = '6Ld5qKcgAAAAAMoywArOgIrC0lQ7NpYUTsF92PIC';
    }
    // Method to load the reCAPTCHA library programmatically
    RecaptchaTokenService.prototype.loadReCaptcha = function () {
        return __awaiter(this, void 0, void 0, function () {
            var script, container;
            return __generator(this, function (_a) {
                if (typeof grecaptcha === 'undefined') {
                    console.log('Google captcha instantiated');
                    script = document.createElement('script');
                    script.src = 'https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoad&render=explicit';
                    script.async = true;
                    script.defer = true;
                    document.head.appendChild(script);
                    window.onRecaptchaLoad = function () { };
                    container = document.querySelector('#' + this.containerId);
                    if (container) {
                        //generate if it doesnt exist
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    // Called to get token
    RecaptchaTokenService.prototype.renderReCaptcha = function () {
        return __awaiter(this, arguments, void 0, function (containerId) {
            var _this = this;
            if (containerId === void 0) { containerId = this.containerId; }
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        try {
                            grecaptcha.render(containerId, {
                                sitekey: _this.sitekey,
                                callback: function (token) { return resolve(token); },
                                size: 'invisible',
                            });
                        }
                        catch (error) {
                            console.error('ERROR GETTING RECAPTCHA TOKEN', error);
                            reject(undefined);
                        }
                    })];
            });
        });
    };
    // Callback when reCAPTCHA is successfully solved
    RecaptchaTokenService.prototype.onSubmit = function (token) {
        console.log('Captcha solved, token:', token);
        // // Make the request to your endpoint with the token
        // this.submitToken(token);
    };
    RecaptchaTokenService.prototype.submitToken = function (token) {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        var body = JSON.stringify({
            recaptchaToken: token,
            // Add other parameters as needed
        });
        // betterFetch(this.endpointUrl, {
        //   method: 'POST',
        //   headers: headers,
        //   body: body,
        // })
        //   .then((response) => response.json())
        //   .then((data) => console.log('Success:', data))
        //   .catch((error) => console.error('Error:', error));
    };
    return RecaptchaTokenService;
}());
exports.RecaptchaTokenService = RecaptchaTokenService;
